/**
 * Logo Lensa — satu tempat untuk empat aset (§G5).
 *
 * Dipakai bersama oleh sidebar, halaman Login, dan Kiosk. Sebelumnya tiap
 * pemakai menyalin markup-nya sendiri, dan tiga salinan itu sempat berbeda
 * ukuran tanpa alasan.
 *
 * Dua sumbu pilihan aset:
 *
 * - `varian` — `lebar` adalah lockup horizontal 3,64:1; `kecil` adalah gembok
 *   persegi dengan wordmark ditumpuk, satu-satunya yang muat di rail ciut 64px.
 * - tema — ditukar CSS lewat kelas `dark` di <html>, BUKAN state React. Skrip
 *   anti-flash di index.html memasang kelas itu sebelum React mount; kalau
 *   pemilihan aset menunggu render pertama, logo mode terang berkedip sekejap
 *   di layar gelap tiap reload.
 *
 * `paksa` mematikan sumbu tema untuk permukaan yang warnanya TIDAK ikut tema.
 * Panel brand di Login misalnya `bg-brand` — navy gelap di mode terang maupun
 * gelap — jadi di sana yang benar selalu varian `gelap`. Menukarnya mengikuti
 * tema justru menaruh logo biru di atas navy, persis kontras tipis yang §G5
 * suruh hindari.
 *
 * Rasio aspek tidak pernah disetel; hanya tingginya yang dikunci lewat
 * `tinggi`.
 */
export function LogoLensa({
  varian = 'lebar',
  tinggi,
  paksa,
  alt = '',
}: {
  varian?: 'lebar' | 'kecil';
  /** Kelas tinggi Tailwind, mis. `h-7 w-auto`. */
  tinggi: string;
  paksa?: 'terang' | 'gelap';
  /**
   * Kosongkan kalau nama aksesibelnya sudah disediakan pembungkusnya (mis.
   * `<span className="sr-only">` di dalam tautan) — kalau tidak, pembaca layar
   * menyebut "Lensa" dua kali untuk satu elemen yang sama.
   */
  alt?: string;
}) {
  const nama = varian === 'kecil' ? 'lensa-kecil' : 'lensa-mode';

  if (paksa) {
    return <img src={`/images/${nama}-${paksa}.png`} alt={alt} className={tinggi} />;
  }

  // Yang tersembunyi ber-`display:none`, jadi ia tidak ikut dibacakan pembaca
  // layar meski `alt`-nya sama — tidak ada duplikasi di sini.
  return (
    <>
      <img src={`/images/${nama}-terang.png`} alt={alt} className={`${tinggi} dark:hidden`} />
      <img src={`/images/${nama}-gelap.png`} alt={alt} className={`hidden ${tinggi} dark:block`} />
    </>
  );
}
